import { MIN_INDEX_FOR_SECOND_ROW, SPECIAL_OFFERS_MAX_CARD } from './constants';
export function isSpecialOffersEmpty(props) {
    return !props.cards || props?.cards.length === 0;
}
export const calcMarginBottom = (length, index) => {
    const currentPosition = index + 1;
    const isMarginForDesktop = length === SPECIAL_OFFERS_MAX_CARD && currentPosition < MIN_INDEX_FOR_SECOND_ROW;
    if (isMarginForDesktop) {
        return '24px';
    }
    return 'auto';
};
export const calcInternalMargin = (length) => {
    if (length === 1) {
        return '48px';
    }
    if (length === 3) {
        return '24px';
    }
    return '32px';
};
export const getItemForTabletView = (card) => {
    const { backgroundImage, title, description, buttonLink, buttonText } = card;
    return {
        image: backgroundImage,
        title,
        description,
        link: buttonLink,
        labelLink: buttonText,
        countLineVisible: 'none',
        isEllipsisEndingLine: false,
    };
};
export const getDataForTabletView = (cards) => cards.map((card) => getItemForTabletView(card));
